import { render, staticRenderFns } from "./SaleGoodCate.vue?vue&type=template&id=083e79ca&"
import script from "./SaleGoodCate.vue?vue&type=script&lang=js&"
export * from "./SaleGoodCate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports